import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'insider-brand_page_header_enroll-click';

/**
 * Brand page header open Insider enrollment modal button click
 */
export function trackInsiderBrandPageHeaderEnrollClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
